export default {
  state: {
    formsPagination: {
      page: 1,
      per_page: 10
    }
  },

  mutations: {
    setMultileadFormsPagination(state, pagination) {
      state.formsPagination = {
        page: pagination.page,
        per_page: pagination.per_page,
        sort_field: pagination.sort_field,
        sort_direction: pagination.sort_direction
      }
    }
  },

  getters: {
    getMultileadFormsPagination: state => state.formsPagination
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/multileads.js